import React from 'react'

import { Container, Row, Col } from 'react-bootstrap'

export default function NoLayout(props) {
    return (
        <div className="App">
            <Container fluid className='vh-100'>

                <Container>
                    <Row>
                        <Col xs={12}>
                            {props.children}
                        </Col>
                    </Row>

                </Container>
            </Container>
        </div>
    )
}
